import MousePosition from 'ol/control/MousePosition.js';
import {transform} from 'ol/proj.js';
import {globalProjection} from "../config/globals";


function formatCoordinate(coordinate) {
    var coords = new transform(coordinate, 'EPSG:3857', 'EPSG:4326');
    return `
    <table>
    <thead>
    <tr>
        <th>Longitude</th>
        <th>Latitude</th>
    </tr>
     </thead>
    <tbody>
        <tr>
        <td>${coords[0].toFixed(6)}</td>
        <td>${coords[1].toFixed(6)}</td>
        </tr>
    </tbody>
    </table>`;
}

export const mousePositionTool = new MousePosition({
    projection: globalProjection,
    coordinateFormat: function(coordinate) {
        return formatCoordinate(coordinate);
    }
})

